let isPdfjsWorkerConfigured = false

/**
 * Configures the pdfjs worker URL once before any `getDocument` call. Shared by
 * upload validation (`src/utils/file.ts`) and plan-review search highlighting.
 *
 * Worker path resolves via Vite's `pdfjs-dist` alias in `web/vite.config.mts` so
 * the worker matches the pdfjs version bundled with react-pdf (see alias comment).
 */
export const configurePdfjsWorker = async () => {
  if (isPdfjsWorkerConfigured) {
    return
  }

  const { pdfjs } = await import('react-pdf')
  pdfjs.GlobalWorkerOptions.workerSrc = new URL(
    'pdfjs-dist/build/pdf.worker.min.mjs',
    import.meta.url
  ).toString()
  isPdfjsWorkerConfigured = true
}
